import { render, staticRenderFns } from "./TTI-Module.vue?vue&type=template&id=a260a1fc&"
import script from "./TTI-Module.vue?vue&type=script&lang=js&"
export * from "./TTI-Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports